exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-quote-container{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:5em 0}@media(max-width: 575px){.no-quote-container{padding-top:2em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/NoQuoteAvailable.scss
// module id = 7583
// module chunks = 13